import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { LiveEventsService } from '../../../util/services/live-events.service';

/** true, wenn beide Zeitpunkte am selben Tag liegen. */
function sameDay(a: Date, b: Date): boolean {
  return a.toDateString() === b.toDateString();
}

/**
 * „Offline – Stand HH:mm“ in der Menüleiste, solange die Live-Verbindung fehlt.
 * Die angezeigten Daten haben dann den Stand des Verbindungsabbruchs.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-live-status',
  imports: [DatePipe, MatIconModule, MatTooltipModule],
  template: `
    @if (live.offlineSince(); as since) {
      <span
        class="offline"
        role="status"
        matTooltip="Keine Verbindung zum Server. Änderungen anderer erscheinen erst wieder, wenn die Verbindung steht."
      >
        <mat-icon aria-hidden="true">cloud_off</mat-icon>
        <span class="label">
          Offline – Stand
          {{ since | date: (isToday(since) ? 'HH:mm' : 'dd.MM. HH:mm') }}
        </span>
      </span>
    }
  `,
  styles: `
    :host {
      display: flex;
      align-items: center;
    }

    .offline {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      margin-right: 8px;
      padding: 2px 10px 2px 6px;
      border-radius: 16px;
      background: #c62828;
      color: #fff;
      font-size: 14px;
      line-height: 24px;
    }

    @media (max-width: 599px) {
      .offline {
        padding: 2px 6px;
      }
      .label {
        position: absolute;
        width: 1px;
        height: 1px;
        overflow: hidden;
        clip: rect(0 0 0 0);
        white-space: nowrap;
      }
    }
  `,
})
export class LiveStatusComponent {
  protected readonly live = inject(LiveEventsService);

  protected isToday(date: Date): boolean {
    return sameDay(date, new Date());
  }
}
